import React from 'react';
import { Link } from '@inertiajs/react';
import Layout from '../../../components/Layout.jsx';
import SalesRepForm from './_Form.jsx';

export default function SuperadminSalesRepsEdit({ sales_rep }) {
  return (
    <Layout>
      <div className="max-w-xl mx-auto p-6 sm:p-8 space-y-6">
        <div>
          <Link href="/superadmin/sales_reps" className="text-sm font-medium text-indigo-600 hover:text-indigo-700">
            ← All sales reps
          </Link>
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900">Edit {sales_rep.name}</h1>
        </div>

        <SalesRepForm
          salesRep={sales_rep}
          submitPath={`/superadmin/sales_reps/${sales_rep.id}`}
          method="patch"
          submitLabel="Save changes"
        />
      </div>
    </Layout>
  );
}
